module.exports = __webpack_public_path__ + "img/promocoes_e_condicoes_icon.a77cd388.svg";